import React from 'react';
import styles from './JobOfferLayout.module.scss';
import classNames from 'classnames';

export default (props: React.PropsWithChildren<{}>) => (
    <div className={styles.content}>
        <div className={classNames(styles.contentContainer)}>{props.children}</div>
    </div>
);
